import { Breadcrumbs, Grid, IconButton } from "@mui/material";
import { PropsWithChildren, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";

type Props = PropsWithChildren<{
  paths?: {
    label: string;
    to: string;
  }[];
  showBack?: boolean;
}>;

const defaultStyle = (active = false) => ({
  fontWeight: 500,
  fontSize: "13px",
  padding: 0,
  margin: 0,
  color: !active ? "#a16ae8" : "#6c757d",
});

const JobBreadcrumbs = ({ paths, showBack = false }: Props) => {
  const navigate = useNavigate();
  const handleBackClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  return (
    <Grid container item gap={2} alignItems="center">
      {showBack && (
        <IconButton size="small" onClick={handleBackClick}>
          <img src="/images/left-arrow.svg" alt="Back" />
        </IconButton>
      )}
      <Breadcrumbs aria-label="breadcrumb" separator="|">
        <Link to="/job-request" style={defaultStyle(paths?.length === 0)}>
          Open Positions
        </Link>
        {paths?.map((path, index) => (
          <Link
            key={index}
            to={path.to}
            style={defaultStyle(index === paths.length - 1)}
          >
            {path.label}
          </Link>
        ))}
      </Breadcrumbs>
    </Grid>
  );
};

export default JobBreadcrumbs;
